import template from './message.edit.html';
import controller from './message.edit.controller';
import './message.edit.scss';

let messageEditComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller
};

export default messageEditComponent;



// WEBPACK FOOTER //
// ./client/app/components/tnt_control/component/message/edit/message.edit.component.js